import { ref, computed, watch, type Ref } from 'vue';
import { type PagerLimit, useRoute } from '~/infrastructure';

interface UsePageReturn {
  currentPage: Ref<number>;
  limit: Ref<PagerLimit>;
  offset: Ref<number>;
  setPage: (page: number, smooth?: boolean) => void;
  setPageLimit: (value: PagerLimit) => void;
}

export default function usePager(): UsePageReturn {
  const route = useRoute();

  const pageFromRoute = route.query?.page as string;

  const currentPage = ref(pageFromRoute != null ? parseInt(pageFromRoute) : 1);
  const limit = ref<PagerLimit>(20);
  const offset = computed(() =>
    limit.value !== 'all' ? (currentPage.value - 1) * limit.value : 0,
  );

  const setPage = (page: number, smooth: boolean = true): void => {
    if (smooth) {
      if (window !== undefined) window.scroll({ top: 0, behavior: 'smooth' });
    }

    currentPage.value = page;
  };

  const setPageLimit = (value: PagerLimit): void => {
    limit.value = value;
  };

  watch(
    () => route.query.page,
    (page) => {
      if (page === undefined) {
        setPage(1);
      } else {
        setPage(Number(page));
      }
    },
  );

  return {
    currentPage,
    limit,
    offset,
    setPage,
    setPageLimit,
  };
}
